/*
 * Scroll Direction
 *
 **/

custom.scrollDirection = (() => {
  // variables
  const scrollDownClass = 'js-scroll-direction-down';
  const scrollUpClass = 'js-scroll-direction-up';
  const scrollTopClass = 'js-scroll-window-top';
  const scrollStartClass = 'js-scroll-start-reached';
  const scrollDepthClass = 'js-scroll-depth-reached';
  const scrollDepthExceededClass = 'js-scroll-depth-exceeded';
  var lastScrollTop = 0;

  const pageHasAlgoliaListing = () => {
    return !!document.querySelector('.product-showcase');
  }

  const navDropdownIsOpen = () => {
    return !!document.querySelector('.navigation--open-dropdown');
  }

  function scrollHandler() {
    var $navigation = $('.navigation');
    var shadowClass = 'has-shadow';
    if ($(window).scrollTop() <= $navigation.height()) {
      $navigation.removeClass(shadowClass);
    } else {
      $navigation.addClass(shadowClass);
    }

    var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
    if (st === 0) {
      // page top code
      document.body.classList.remove(scrollUpClass);
      document.body.classList.remove(scrollDownClass);
      document.body.classList.add(scrollTopClass);
    } else if (st > lastScrollTop) {
      // downscroll code
      // keep the nav in view while a desktop dropdown is open
      if (!navDropdownIsOpen()) {
        document.body.classList.remove(scrollUpClass);
        document.body.classList.remove(scrollTopClass);
        document.body.classList.add(scrollDownClass);
      }
    } else {
      // upscroll code
      document.body.classList.remove(scrollDownClass);
      document.body.classList.remove(scrollTopClass);
      document.body.classList.add(scrollUpClass);
    }
    if(pageHasAlgoliaListing()) {
      const $algoliaListing = $('.product-showcase');
      const algoliaListingHeight = $algoliaListing.outerHeight();
      const algoliaListingTop = $algoliaListing.offset().top;
      const scrollDepth = algoliaListingTop + (algoliaListingHeight / 4);
      const scrollDepthBottom = algoliaListingTop + algoliaListingHeight - window.innerHeight - 300;
      if(st > algoliaListingTop) {
        document.body.classList.add(scrollStartClass);
      } else {
        document.body.classList.remove(scrollStartClass);
      }
      if (st > scrollDepth) {
        document.body.classList.add(scrollDepthClass);
      } else {
        document.body.classList.remove(scrollDepthClass);
      }
      if (st > scrollDepthBottom) {
        document.body.classList.add(scrollDepthExceededClass);
      } else {
        document.body.classList.remove(scrollDepthExceededClass);
      }
    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  }

  function init() {
    window.addEventListener('scroll', custom.utils.debounce(scrollHandler, 50), false);
  }

  return {
    init,
  };
})();
custom.scrollDirection.init();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/scroll-direction.js